<template>
  <v-container fluid class="change-password-page">
    <v-card class="change-password-form rounded-lg elevation-3">
      <v-card-title class="primary white--text py-3 px-4">
        <v-icon left color="white">mdi-lock-reset</v-icon>
        Change Password
      </v-card-title>
      <v-card-text class="pa-5">
        <p class="grey--text text--darken-1 mb-5">
          Perbarui password akun Anda secara berkala untuk menjaga keamanan.
        </p>
        <v-form ref="form" @submit.prevent="submit">
            <v-text-field
              v-model="form.currentPassword"
              label="Password Saat Ini"
              :type="showCurrent ? 'text' : 'password'"
              :append-icon="showCurrent ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showCurrent = !showCurrent"
              outlined
              dense
              prepend-inner-icon="mdi-lock-outline"
              :rules="[v => !!v || 'Password saat ini wajib diisi']"
              class="mb-3"
            />
            <v-text-field
              v-model="form.newPassword"
              label="Password Baru"
              :type="showNew ? 'text' : 'password'"
              :append-icon="showNew ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showNew = !showNew"
              outlined
              dense
              prepend-inner-icon="mdi-lock-plus-outline"
              :rules="[
                v => !!v || 'Password baru wajib diisi',
                v => (v && v.length >= 6) || 'Password minimal 6 karakter',
              ]"
              class="mb-3"
            />
            <v-text-field
              v-model="form.confirmPassword"
              label="Konfirmasi Password Baru"
              :type="showConfirm ? 'text' : 'password'"
              :append-icon="showConfirm ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showConfirm = !showConfirm"
              outlined
              dense
              prepend-inner-icon="mdi-lock-check-outline"
              :rules="[
                v => !!v || 'Konfirmasi password wajib diisi',
                v => v === form.newPassword || 'Password tidak cocok',
              ]"
              class="mb-2"
            />
            <v-btn
              color="primary"
              :loading="loading"
              :disabled="loading"
              type="submit"
              block
              large
              class="text-white mt-3"
              style="border-radius: 8px; font-weight: 600;"
            >
              <v-icon left>mdi-content-save</v-icon>
              Simpan Password
            </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout" top>
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "ChangePasswordPanel",
  data() {
    return {
      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      showCurrent: false,
      showNew: false,
      showConfirm: false,
      loading: false,
      snackbar: {
        visible: false,
        color: "success",
        text: "",
        timeout: 4000,
      },
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      try {
        await this.$axios.post(
          `${process.env.VUE_APP_URL}/api/change-password`,
          {
            current_password: this.form.currentPassword,
            new_password: this.form.newPassword,
            new_password_confirmation: this.form.confirmPassword,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
            },
          }
        );

        this.snackbar = {
          visible: true,
          color: "success",
          text: "Password berhasil diubah.",
          timeout: 3000,
        };

        this.form.currentPassword = "";
        this.form.newPassword = "";
        this.form.confirmPassword = "";
        this.$refs.form.resetValidation();
      } catch (error) {
        const errors = error.response?.data?.errors;
        const message = errors
          ? Object.values(errors)[0][0]
          : error.response?.data?.message || "Gagal mengubah password.";

        this.snackbar = {
          visible: true,
          color: "error",
          text: message,
          timeout: 5000,
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.change-password-page {
  display: flex;
  justify-content: center;
  padding-top: 24px;
}
.change-password-form {
  width: 340px;
  max-width: 100%;
}
</style>
